"use strict";
(function () {
  if (!customElements.get("vat-calculator")) {
    class VatCalculator extends HTMLElement {
      constructor() {
        super();
        this.elements = {};
        this.vatRate = 0;
        this.currencySymbol = this.dataset.currencySymbol || "$";
        this.country = this.dataset.vatCountry || "";
        this.taxesIncluded = this.dataset.taxes === "true";
        this.onSwatchChange = this.onSwatchChange.bind(this);
        this.defaultPrices = []; // store original base prices and tax flag
      }

      connectedCallback() {
        this.setupElements();
        this.calculateVatRate();
        if (this.vatRate === 0) {
          this.style.display = "none";
          return;
        }
        this.saveDefaultPrices();
        this.addEventListeners();
        if (this.elements.swatch) {
          this.elements.swatch.checked = this.taxesIncluded;
          this.updatePrices(this.taxesIncluded);
        }
      }

      setupElements() {
        this.elements.swatch = this.querySelector('[data-component="swatch"]');
        const prices = this.dataset.prices;
        if (prices) {
          const selector = prices.split(";").map((p) => `[data-component="${p}"]`).join(",");
          this.elements.pricesToUpdate = this.closest(".product__info-wrapper")?.querySelectorAll(selector);
        }
      }

      saveDefaultPrices() {
        if (!this.elements.pricesToUpdate) return;
        this.defaultPrices = [];
        this.elements.pricesToUpdate.forEach((el) => {
          const base = el.dataset.basePrice ? Number(el.dataset.basePrice) : this.parsePrice(el.innerText);
          this.defaultPrices.push({
            el: el,
            basePrice: base,
            includesTax: this.taxesIncluded
          });
        });
      }

      addEventListeners() {
        if (this.elements.swatch) this.elements.swatch.addEventListener("change", this.onSwatchChange);
      }

      calculateVatRate() {
        const vatByCountry = {
          AT: 20, BE: 21, BG: 20, CY: 19, CZ: 21, DK: 25, FR: 20, DE: 19, GR: 24,
          HU: 27, IE: 23, IT: 22, LV: 21, LU: 17, MT: 18, NL: 21, PL: 23, PT: 23,
          ES: 21, SE: 25, AU: 10, GB: 20, NO: 25, CH: 8, US: 0, CA: 5
        };
        this.vatRate = vatByCountry[this.country] || 0;
      }

      parsePrice(text) {
        if (!text) return 0;
        const clean = text.replace(/[^0-9.]/g, "");
        return Number(clean) || 0;
      }

      formatPrice(value) {
        return this.currencySymbol + Number(value).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: true
        });
      }

      onSwatchChange(e) {
        const checked = e.target.checked;
        this.updatePrices(checked);
      }

      updatePrices(taxIncluded) {
        if (!this.defaultPrices || this.vatRate === 0) return;
        this.defaultPrices.forEach(({ el, basePrice, includesTax }) => {
          let updated;
          if (includesTax) {
            updated = taxIncluded ? basePrice : basePrice / (1 + this.vatRate / 100);
          } else {
            updated = taxIncluded ? basePrice * (1 + this.vatRate / 100) : basePrice;
          }
          el.innerText = this.formatPrice(updated);
        });
      }
    }

    customElements.define("vat-calculator", VatCalculator);
  }
})();
